import { render } from "./EmptyData.vue?vue&type=template&id=1757b524&scoped=true"
const script = {}

import "./EmptyData.vue?vue&type=style&index=0&id=1757b524&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/saas-settlement-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1757b524"]])

export default __exports__